import * as tslib_1 from "tslib";
import * as React from 'react';
import { StyledIconBase } from '../../StyledIconBase';
export var Hot = React.forwardRef(function (props, ref) {
    var attrs = {
        "fill": "currentColor",
    };
    return (React.createElement(StyledIconBase, tslib_1.__assign({ iconAttrs: attrs, iconVerticalAlign: "middle", iconViewBox: "0 0 24 24" }, props, { ref: ref }),
        React.createElement("path", { d: "M14.002 7.376C12.93 4.145 9.538 2.659 9.394 2.598L8 2v1.517C8 6.043 6.307 7.795 6.293 7.81 4.107 9.994 3 12.251 3 14.517c0 2.846 1.136 4.876 2.812 6.182C5 17.656 8 13.517 8 13.517c.846 5.914 7.377 6.828 9.39 6.971 1.554-1.31 2.609-3.267 2.609-5.936.006-.162.112-3.988-2.245-6.692l-1.392-1.597-.349 2.09c-.356 2.138-1.172 3.518-2.339 4.003.736-1.747.847-3.418.328-4.98z", key: "k0" })));
});
Hot.displayName = 'Hot';
export var HotDimensions = { height: 24, width: 24 };
